import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

import ModalDialog from './ModalDialog.react';

const StyledButton = styled(Button)(({ theme }) => {
  return {
    margin: theme.spacing(0.5),
  };
});

const DeleteModalDialog = ({ open, onClose, onDelete, title, message }) => {
  return (
    <ModalDialog title={title} message={message} open={open} onClose={onClose}>
      <StyledButton color="primary" onClick={onClose}>
        Cancel
      </StyledButton>
      <StyledButton
        color="primary"
        onClick={() => {
          onDelete();
          onClose();
        }}
      >
        Delete
      </StyledButton>
    </ModalDialog>
  );
};

DeleteModalDialog.propTypes = {
  title: PropTypes.object.isRequired,
  message: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default DeleteModalDialog;
